import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
    BuildingContactViewPaginatedResultDto,
    BuildingView,
    ContactClient,
    ContactView,
    ContactViewPaginatedResultDto,
    QuickSearchContactsParameters,
    SearchAvailableContactBuildingsParameters,
    SearchContactsForAccountParameters,
    SearchContactsForBuildingParameters,
    SearchContactsForCompanyParameters,
    SearchContactsParameters
} from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ContactService {
    constructor(private readonly client: ContactClient) {}

    async getById(id: number): Promise<ContactView> {
        return await lastValueFrom(this.client.contactGetById(id));
    }

    async save(body: ContactView): Promise<ContactView> {
        return await lastValueFrom(this.client.contactSave(body));
    }

    async searchContacts(body: SearchContactsParameters | undefined): Promise<ContactViewPaginatedResultDto> {
        return await lastValueFrom(this.client.contactSearch(body));
    }

    async searchContactsForBuilding(
        body: SearchContactsForBuildingParameters | undefined
    ): Promise<BuildingContactViewPaginatedResultDto> {
        return await lastValueFrom(this.client.contactSearchForBuilding(body));
    }

    async searchContactsForCompany(
        body: SearchContactsForCompanyParameters | undefined
    ): Promise<ContactViewPaginatedResultDto> {
        return await lastValueFrom(this.client.contactSearchForCompany(body));
    }

    async searchContactsForAccount(
        body: SearchContactsForAccountParameters | undefined
    ): Promise<ContactViewPaginatedResultDto> {
        return await lastValueFrom(this.client.contactSearchForAccount(body));
    }

    async search(body: QuickSearchContactsParameters | undefined): Promise<ContactView[]> {
        return await lastValueFrom(this.client.contactQuickSearch(body));
    }

    async searchAvailableBuildings(body: SearchAvailableContactBuildingsParameters): Promise<BuildingView[]> {
        return await lastValueFrom(this.client.contactSearchAvailableBuildings(body));
    }

    async activate(id: number): Promise<void> {
        return await lastValueFrom(this.client.contactActivate(id));
    }

    async deactivate(id: number): Promise<void> {
        return await lastValueFrom(this.client.contactDeactivate(id));
    }

    async setAsMain(id: number): Promise<void> {
        return await lastValueFrom(this.client.contactSetAsMain(id));
    }

    async unsetAsMain(id: number): Promise<void> {
        return await lastValueFrom(this.client.contactUnsetAsMain(id));
    }
}
